<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'userindex',
})
</script>
<template>
  <a-spin :spinning="loading">
    <div class="page-header-index-wide page-header-wrapper-grid-content-main">
      <a-row :gutter="24">
        <a-col :md="24"  :lg="12">
          <a-card :bordered="false">
            <div class="account-center-avatarHolder">
              <a-avatar :size="96" @click="openAvatar" :src="addip(userInfo.pic)"></a-avatar>
              <LanseedImgcropper v-model:open="visible" @change="setavatar" :img="addip(userInfo.pic)" />
              <!-- 上传头像 -->
              <div class="username">{{userInfo.userid}}</div>
              <div class="bio">{{userInfo.username}}</div>
            </div>

            <!-- 详情 -->
            <div class="account-center-detail">
              <div class="flex1">
                <p>
                <UserAddOutlined /> {{userInfo.tel}}
              </p>
              <p>
                <SmileOutlined /> {{userInfo.rolename}}
              </p>
              <p>
                <IdcardOutlined /> {{userInfo.province}} {{userInfo.city}} {{userInfo.area}} {{userInfo.address}}
              </p>
              </div>
            </div>
            <div class=" flex align-center">
                <a-button class="margin" type="primary" @click="onEdit"><FormOutlined /> 修改资料</a-button>
                <a-button class="margin"  type="primary" @click="onPassword"><SafetyCertificateOutlined /> {{ $t('account.passwordsafe') }}</a-button>
            </div>
              <a-divider :dashed="true" />
              <div >
                <div class="margin-right-sm padding-sm">部门/公司</div>
                <div  class="padding-sm flex align-center flex1"  v-for="(item,i) in userInfo.companlys" :key="i">
                        <a-avatar class=" margin-right-sm" size="small"  src="/account/levelOneDept.png" />
                        <span class="member  margin-right-sm">  {{ item.title }} </span>
                        <span class="member text-gray">  {{ item.job }}</span>
                </div>
              </div>
          </a-card>
        </a-col>
        <a-col :md="24" :lg="12">
          <workgroup></workgroup>
        </a-col>

      </a-row>
    </div>
    <lanseed-form v-model:open="edit" :data="userInfo" :rules="rules" @change="infoChange"></lanseed-form>
    <password ref="pwd"></password>
  </a-spin>
</template>

<script lang="ts" setup name="userindex">
import LanseedImgcropper from '@/components/lanseed/imgcropper.vue'
import { ref, reactive, onMounted } from 'vue'
import { useMessage } from '@/hooks/useMessage'
import  api from '@/utils/http/service'
import { divisionStringToArray, separator,addip } from '@/utils/util'
import { getPersonDetail } from './hooks'
import { UpdateUserLabel, UserInfo } from './types'
import { UserAddOutlined ,SmileOutlined,IdcardOutlined,FormOutlined,SafetyCertificateOutlined} from '@ant-design/icons-vue'
import { useI18n } from 'vue-i18n'
import LanseedForm from '@/components/lanseed/form.vue'
import workgroup from './workgroup.vue'
import password from './password.vue'
    const { t } = useI18n()
    const visible=ref<boolean>(false)
    const tabListNoTitle = [
      {
        key: 'passwordsafe',
        tab: t('account.passwordsafe')
      }
    ]
    const pwd=ref()
    let rules=reactive<any>({
      pic:{domtype:'img',max:1,name:'头像'},
      username:{name:'昵称',required:true},
      tel:{name:'电话',required:true},
      enable:{name:'启用',value:true,domtype:'switch'},
      address:{name:'详细地址'},
    })
    const noTitleKey = 'passwordsafe'
    const edit=ref<Boolean>(false)
    let citys=reactive<Array>([])

    let userInfo = ref<any|null>({})

    const loading = ref<Boolean>(false)
    const allSkills = ref<String[]>([])
    const allInterest = ref<String[]>([])

    const showBaseSetting = ref<Boolean>(false)
    const openAvatar=():void=>{
      visible.value=true
    }
    const getInitData= ():void=>{
      loading.value = true
      api.user.self().then(res=>{
        loading.value = false
          if(res.state==1){
            userInfo.value=res.data
            showBaseSetting.value=true
          }
      })
    }

    onMounted(() => {
      getInitData()
    })
    const onPassword=()=>{
      pwd.value.open()
    }
    const onEdit=():void=>{
      edit.value=true
    }
    const setavatar = async url => {
      userInfo.value.pic = url
      loading.value = true
      api.user.change(userInfo.value).then(res=>{
        loading.value = false
      })
    }
    const infoChange=(e):void=>{
      if(e.citys.length>0){
        userInfo.value.province=e.citys[0]
        userInfo.value.city=e.citys[1]
        userInfo.value.area=e.citys[2]
      }
       userInfo.value.username=e.username
       userInfo.value.tel=e.tel
       userInfo.value.pic=e.pic
       userInfo.value.address=e.address
       loading.value=true
       api.user.change(userInfo.value).then(res=>{
        loading.value = false
        if(res.state==1){
          userInfo.value=res.data
          edit.value=false
        }

      })
    }

    const { createMessage } = useMessage()


    const handleTabChange = (key, type) => {}

</script>

<style lang="less" scoped>
.page-header-wrapper-grid-content-main {
  width: 100%;
  height: 100%;
  min-height: 100%;
  transition: 0.3s;

  .account-center-avatarHolder {
    text-align: center;
    margin-bottom: 24px;

    & > .avatar {
      margin: 0 auto;
      width: 104px;
      height: 104px;
      margin-bottom: 20px;
      border-radius: 50%;
      overflow: hidden;
      img {
        height: 100%;
        width: 100%;
      }
    }

    .username {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
      line-height: 28px;
      font-weight: 500;
      margin-bottom: 4px;
    }
  }

  .account-center-detail {
    p {
      margin-bottom: 8px;
      padding-left: 10px;
      position: relative;
    }

    i {
      // position: absolute;
      // height: 14px;
      // width: 14px;
      // left: 0;
      // top: 4px;
      padding-right: 5px;
      // background: url(https://gw.alipayobjects.com/zos/rmsportal/pBjWzVAHnOOtAUvZmZfy.svg);
    }

    .title {
      background-position: 0 0;
    }
    .group {
      background-position: 0 -22px;
    }
    .address {
      background-position: 0 -44px;
    }
  }

  .account-center-tags {
    .ant-tag {
      margin-bottom: 8px;
    }
  }

  .account-center-team {
    .members {
      a {
        display: block;
        margin: 12px 0;
        line-height: 24px;
        height: 24px;
        .member {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          line-height: 24px;
          // max-width: 100px;
          vertical-align: top;
          margin-left: 12px;
          transition: all 0.3s;
          display: inline-block;
        }
        &:hover {
          span {
            color: #1890ff;
          }
        }
      }
    }
  }

  .tagsTitle,
  .teamTitle {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 12px;
  }
}

.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto 10px auto;
  width: 100%;
  max-width: 130px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
